export default function register() {
  if (
    process.env.NODE_ENV === 'production' &&
    'serviceWorker' in navigator
  ) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then(registration => {
          console.log(
            'Service worker registered:',
            registration.scope
          );

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;

            if (!installingWorker) {
              return;
            }

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('New service worker installed.');

                  /*
                   * Tell the new worker to activate immediately.
                   *
                   * Your service-worker.js also has self.skipWaiting(),
                   * so this is an additional safeguard.
                   */
                  installingWorker.postMessage({
                    type: 'SKIP_WAITING',
                  });
                } else {
                  console.log(
                    'Service worker installed for the first time.'
                  );
                }
              }
            };
          };
        })
        .catch(error => {
          console.error(
            'Error during service worker registration:',
            error
          );
        });

      /*
       * When the new service worker takes control, reload the page
       * so the application runs the new JS/CSS bundle.
       */
      let refreshing = false;

      navigator.serviceWorker.addEventListener(
        'controllerchange',
        () => {
          if (refreshing) {
            return;
          }

          refreshing = true;

          console.log(
            'New service worker took control. Reloading application.'
          );

          window.location.reload();
        }
      );
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.unregister();
      });
    });
  }
}